<template>
  <li>
    <div class="form-check">
      <div class="node-info-container" v-show="is_visible">
        <span class="toggle_children" v-if="must_show_toggler" @click="toggle_children">
          <i class="fas fa-plus" v-if="!show_children"></i>
          <i class="fas fa-minus" v-else-if="show_children"></i>
        </span>
        <input
          v-if="show_checkbox"
          type="checkbox"
          class="form-check-input"
          :value="id"
          :id="id"
          v-model="checked"
          @click="toggle_check"
          ref="checkbox"
        />
        <label class="form-check-label" :for="id" v-bind:class="{ 'font-weight-bold': is_changed,
                                         'no_result_filter': has_no_results,
                                         'selected_filter': is_searched,
                                         'ml-n4': virtual}">
          {{ name }}
          <span class="badge badge-pill badge-secondary">{{ total }}</span>
        </label>
      </div>
      <ul class="list-unstyled">
        <transition-group name="fade" v-for="(child, index) in children" :key="calculate_transition_facet_key(child.id, index)">
          <forms-tree-node-facet-vue
            v-show="must_show_children"
            :key="`tree_node_facet_child_${child.id}`"
            v-bind="child"
            :filter="filter"
            :is_filtering="is_filtering"
            :selected="selected"
            :auto_select_children="auto_select_children"
            :counts_visible="counts_visible"
            :only_selection_visible="only_selection_visible"
            ref="children"
            @update_selected="update_selected"
            @status_changed="child_changed"
            class="font-weight-normal"
            :applied_values="applied_values"
            :indeterminate-available="indeterminateAvailable"
          />
        </transition-group>
      </ul>
    </div>
  </li>

</template>

<script>
  import mixins from 'common/mixins.js'
  import CheckBoxTreeNode from 'components/forms/CheckBoxTreeNode'

  export default {
    name: 'forms-tree-node-facet-vue',
    props: {
      applied_values: { type: Array, default: () => []},
    },
    extends: CheckBoxTreeNode,
    computed: {
      is_changed() {
        return this.selected.includes(this.id) != this.applied_values.includes(this.id)
      },
      is_searched() {
        return this.applied_values.includes(this.id)
      },
      has_no_results() {
        return this.total == 0
      },
    },
    methods: {
      calculate_transition_facet_key(facet_id, number) {
        return ("transition_"+facet_id+"_"+number)
      }
    }
  }
</script>
